"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryPickerDesktop = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CountryTable = require("./Desktop/CountryTable");
var _SearchSelect = require("../SearchSelect");
var _CustomCountryOption = require("./Desktop/CustomCountryOption");
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Components:

// Interfaces:

var getStyles = function getStyles(showAutocomplete) {
  return {
    menu: function menu() {
      return {
        boxShadow: "0px 1px 2px rgba(210, 208, 197, 0.9),\n    0px 10px 15px rgba(216, 214, 204, 0.9)",
        width: 240,
        overflow: showAutocomplete ? 'hidden' : 'visible'
      };
    },
    menuList: function menuList() {
      return {
        maxHeight: 489,
        overflow: showAutocomplete ? 'auto' : 'initial'
      };
    }
  };
};
var CountryPickerDesktop = exports.CountryPickerDesktop = /*#__PURE__*/_react["default"].memo(function (props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    _props$hasError = props.hasError,
    hasError = _props$hasError === void 0 ? false : _props$hasError,
    currentCountry = props.currentCountry,
    onChangeCountry = props.onChangeCountry,
    inputValue = props.inputValue,
    onInputChange = props.onInputChange,
    allCountries = props.allCountries,
    autocompleteOptions = props.autocompleteOptions,
    availableCountries = props.availableCountries,
    priorityCountries = props.priorityCountries;
  var countries = [].concat((0, _toConsumableArray2["default"])(availableCountries), (0, _toConsumableArray2["default"])(priorityCountries));
  var hasCountries = !(0, _isEmpty2["default"])(countries);
  var showAutocomplete = Boolean(hasCountries && inputValue);
  var handleChange = function handleChange(val) {
    return onChangeCountry(val);
  };
  var handleInputChange = function handleInputChange(val) {
    return onInputChange(val);
  };
  var handleKeyDown = function handleKeyDown(e) {
    var SPACEBAR = 32;
    if (e.keyCode === SPACEBAR && !inputValue) e.preventDefault();
  };
  var CustomTable = function CustomTable(_ref) {
    var selectOption = _ref.selectOption;
    return /*#__PURE__*/_react["default"].createElement(_CountryTable.CountryTable, {
      allCountries: allCountries,
      availableCountries: availableCountries.slice(0, 56),
      priorityCountries: priorityCountries,
      onChoose: function onChoose(val) {
        return selectOption(val);
      }
    });
  };
  var Option = {
    custom: true,
    CustomComponent: CustomTable
  };
  var memoOptions = showAutocomplete ? autocompleteOptions : [Option];
  var CustomOption = showAutocomplete ? _CustomCountryOption.CustomCountryOption : null;
  var customStyles = (0, _react.useMemo)(function () {
    return getStyles(showAutocomplete);
  }, [showAutocomplete]);
  return /*#__PURE__*/_react["default"].createElement(StyledWrapper, {
    className: className,
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(StyledTooltip, {
    shown: hasError,
    content: "\u041A\u0443\u0434\u0430 \u0431\u044B \u0432\u044B \u0445\u043E\u0442\u0435\u043B\u0438 \u043F\u043E\u043B\u0435\u0442\u0435\u0442\u044C?"
  }), /*#__PURE__*/_react["default"].createElement(_SearchSelect.SearchSelect, {
    value: currentCountry,
    defaultValue: currentCountry,
    name: "Country",
    placeholder: "\u041A\u0443\u0434\u0430",
    isLoading: isLoading,
    loadingMessage: function loadingMessage() {
      return 'Поиск направлений';
    },
    noOptionsMessage: function noOptionsMessage() {
      return 'Нет таких направлений';
    },
    onChange: handleChange,
    onInputChange: handleInputChange,
    onKeyDown: handleKeyDown,
    inputValue: inputValue,
    options: memoOptions,
    CustomOption: CustomOption,
    customStyles: customStyles,
    getOptionLabel: function getOptionLabel(option) {
      return option.name_ru;
    },
    getOptionValue: function getOptionValue(option) {
      return option.code;
    }
    // Flags:
    ,
    blurInputOnSelect: false,
    isClearable: true,
    isSearchable: true
  }));
});
CountryPickerDesktop.displayName = 'CountryPicker';
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "CountryPickerdesktop__StyledWrapper",
  componentId: "sc-rbbjuc-0"
})(["position:relative;", ""], function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError && '.react-select__control { background: #FFFBE5; border: 1px solid #FFD600;}';
});
var StyledTooltip = (0, _styledComponents["default"])(_Tooltip["default"]).withConfig({
  displayName: "CountryPickerdesktop__StyledTooltip",
  componentId: "sc-rbbjuc-1"
})(["bottom:0 !important;border-radius:4px !important;box-shadow:0px 8px 8px 0px rgba(0,0,0,0.2) !important;padding:8px !important;border:0 !important;width:fit-content !important;white-space:nowrap !important;height:44px !important;left:50% !important;transform:translateX(-50%) !important;margin:0 !important;"]);